<template>
  <div>
    <div>
      <SystemAlert/>
    </div>

    <div class="declaimer">      
      <button
        type="button" class="app-btn-selectable __active app-btn-custom" ref="btnIndividual"
        @click.prevent="toggleActiveClass({ indType: true })">
        I'm an individual
      </button>
      
      <button 
        type="button" class="app-btn-selectable app-btn-custom"  ref="btnBusiness" 
        @click.prevent="toggleActiveClass({ indType: false })">
        I'm a business     
      </button>
    </div>

    <div class="app-main-content guest-signin d-flex" v-if=" this.isIndividual ==true">  
      <div class="ind-signin">
        <h1>Sign in</h1>
        <div class="select-ind"  v-if=" this.isIndividual ==true">
          <div class="radio-group">
            <input type="radio" id="License-RI" v-model="authorizeId" value=1 name="authorizeId" @change="resetForm()" class="radio-input">
            <label for="License-RI" class="radio-label">I have RI License / ID card</label>
          </div>
          <div class="radio-group">
            <input type="radio" id="Vehicle-RI" v-model="authorizeId" value=2 name="authorizeId" @change="resetForm()" class="radio-input">
            <label for="Vehicle-RI" class="radio-label">I have a vehicle in RI</label>
          </div>
          <div class="radio-group">
            <input type="radio" id="Violation-Suspension-RI" v-model="authorizeId" value=3 name="authorizeId" @change="resetForm()" class="radio-input">
            <label for="Violation-Suspension-RI" class="radio-label">I have a violation / suspension in RI </label>
          </div>
          <div class="radio-group"> 
            <input type="radio" id="Crash-RI" v-model="authorizeId" value=4 name="authorizeId" @change="resetForm()" class="radio-input">
            <label for="Crash-RI" class="radio-label">I have a crash record in RI</label>
          </div>
        </div>
        <LoginForm :selectId="authorizeId" ref="LoginForm"/>
      </div>
      <div v-if="authorizeId=='3'" class="susp-box">
        <Aside>
          <div  >
            <p>
              You can get <strong> Case / Summons / Ticket Number </strong> information on the RI DMV's Notice of action that was mailed to you <br />
              OR <br />
              On the <a href="https://publicportal.courts.ri.gov/PublicPortal" target="_blank" rel="noopener noreferrer">RI Courts public portal</a> 
            </p>
          </div>
        </Aside>
      </div>

    </div>
    <div class="app-main-content guest-signin" v-if=" this.isIndividual ==false">
      <h1>Online Services</h1>   
      <p>For customers unable to use the DMV portal.</p>
      <p>
        <a href="https://www.ri.gov/DMV/registration_renewal/" target="_blank" rel="noopener noreferrer"> Registration Renewal </a>
      </p>
      <p>
        <a href="https://www.ri.gov/DMV/duplicate_registration/" target="_blank" rel="noopener noreferrer"> Duplicate Registration </a>
      </p>
      <p>
        <a href="https://www.ri.gov/DMV/cancel_registration/" target="_blank" rel="noopener noreferrer"> Cancel Registration </a>
      </p>
      <p>
        <a href="https://www.ri.gov/DMV/address_change/" target="_blank" rel="noopener noreferrer"> Update Address </a>
      </p>
    </div>
  </div>
</template>

<script>
import appConfig from '@/app.config'
import LoginForm from '../../components/modules/guestLogin/LoginForm.vue';
import SystemAlert from '@/components/SystemAlert'
import Aside from '../../components/confirmation/Aside.vue';

export default {
  name: 'GuestSignin',
  page: {
    title: `Guest Sign in Page | ${appConfig.shortName}`,
    meta: [
      {
        name: 'description',
        content: 'Sign in to view your profile'
      }
    ]
  },
  mounted() {
    this.activeTab = this.$route.query.activeTab;
    if(this.activeTab == 'businesspage') {
      this.toggleActiveClass({ indType: false });
    }
    else {
      this.toggleActiveClass({ indType: this.isIndividual });
    }
    window.scroll(0,0);
    document.body.setAttribute("tabindex", "1");
    document.body.focus();

    document.body.removeAttribute("tabindex");
    document.getElementById("app").scrollTop = 0;
  },
  components: {
    LoginForm,
    SystemAlert,
    // Maintenance
    Aside
},
  data() {
    return {
      isIndividual: true,
      authorizeId: 1,
      activeTab: ''
    }
  },
  methods:{
    toggleActiveClass(data) {
      this.isIndividual = data.indType;         // determines if Individual or Business form will show
      const btnIn = this.$refs.btnIndividual;
      const btnBu = this.$refs.btnBusiness;
      const activeClass = '__active';

      if (this.isIndividual) {
        if (btnIn && !btnIn.classList.contains(activeClass)) {
          btnIn.classList.add(activeClass);
          btnBu.classList.remove(activeClass);
        }
      } else {
        if (btnBu && !btnBu.classList.contains(activeClass)) {
          btnBu.classList.add(activeClass);
          btnIn.classList.remove(activeClass);
        }
      }
    },
    resetForm() {
      this.$refs.LoginForm.getFormReset();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@ridmv/web-themes/styles/loading";
  .declaimer {
    color:black;
    width: 100%;
    height: 100%;
    font-size: 12px;
    padding-left: 6%;
    padding-right: 6%;
    padding-top: 1%;
  }

  .app-btn-custom {
    text-indent: 1%; 
    height: 75px; 
    width: 25%;

    @media only screen and (max-width: 932px) {
      width: 45%;
    }
  }

  .select-ind{
    display: flex;
    gap: 2rem;
    .radio-group{
      width: max-content;
      input[type="radio"]:checked + label
      {
        font-weight: bold;
      }
    }
    @media only screen and (max-width: 900px) {
      display: block;
    }
  }

  .d-flex {
    display: flex;
    align-items: center;
    .susp-box {
      width: 30%;
      @media only screen and (max-width: 599px) {
        width: 100%;
      }
    }
    .app-notice {
      max-width: 100% !important;
    }
  }
  .ind-signin {
    width: 100%;
    @media only screen and (max-width: 599px) {
      width: 100%;
    }
  }

  .radio-group {
    .radio-input {
      display: inline-block;
      vertical-align: middle;
    }
  }
  @media only screen and (max-width: 1280px) {
    .d-flex {
      display: block;
      .susp-box {
        width: 100%;
      } 
    }
  }
</style>